'use strict';

const regexRFCPhysics = '^[A-ZÑ]{4}\\d{6}[A-Z0-9]{3}$';
const regexRFCMoral = '^[A-Z&]{3}\\d{6}[A-Z0-9]{3}$';

module.exports = {
    regexRFCPhysics: regexRFCPhysics,
    regexRFCMoral: regexRFCMoral
}